export function generateRedirectUrl(redirectTo: string, tmpId: string | null) {
  if (tmpId) {
    const param = redirectTo.includes('?') ? '&tmpId' : '?tmpId';
    return `${redirectTo}${param}=${tmpId}`;
  }

  return redirectTo;
}
